import React from "react";
import { Badge } from "reactstrap";
import useApi from "~/hooks/use-api";

interface Props {
  appStats: AppStats | null;
}

interface Release {
  version: string;
  changelog: string;
  url: string;
}

interface AppStats {
  iosAppVersion?: string;
  androidAppVersion?: string;
}

export default function VersionBadge(props: Props) {
  const { appStats } = props;
  const { data: stable } = useApi<Release>("/api/release/stable");

  if (!appStats) {
    return <Badge color="danger">Not Configured</Badge>;
  }

  if (appStats.iosAppVersion === appStats.androidAppVersion) {
    return (
      <ColorBadge
        version={appStats.iosAppVersion}
        stable={stable && stable.version}
      />
    );
  }

  return (
    <>
      <ColorBadge
        label="iOS:"
        version={appStats.iosAppVersion}
        stable={stable && stable.version}
      />{" "}
      <ColorBadge
        label="And:"
        version={appStats.androidAppVersion}
        stable={stable && stable.version}
      />
    </>
  );
}

function ColorBadge(props: {
  version?: string;
  stable: string | null;
  label?: string;
}) {
  if (!props.version) {
    return (
      <Badge color="secondary">
        {props.label}
        None
      </Badge>
    );
  }

  let color = "secondary";
  if (props.stable) {
    color = props.version === props.stable ? "success" : "warning";
  }

  return (
    <Badge color={color}>
      {props.label}
      {props.version}
    </Badge>
  );
}
